export default __webpack_public_path__ + "static/media/greg.befe6104.jpeg";